import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Row } from 'react-grid-system';
import classNames from 'classnames/bind';

import styles from './index.module.scss';
import ItemSmall from './ItemSmall';
import { newMenuListActions } from '../../../../actions';

const cx = classNames.bind(styles);

class RelList extends Component {

  componentDidMount() {
    if (this.props.newMenuList.data.length === 0) {
      this.props.actions.newMenuListActions.request();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { newMenuList } = nextProps;
    return !newMenuList.isProcessing && !newMenuList.failure;
  }

  render() {
    const { newMenuList } = this.props;

    return (
      <div className={cx('container')}>
        <Container>
          <Row>
            {newMenuList.data.map((newMenu, i) => {
              if (i < 4) {
                return (
                  <ItemSmall key={String(newMenu.id)} item={newMenu} />
                );
              } else {
                return null;
              }
            })}
          </Row>
        </Container>
      </div>
    );
  }
}


/**
 * Define redux settings
 */
const mapStateToProps = (state) => {
  const { newMenuList } = state;
  return {
    newMenuList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      newMenuListActions: bindActionCreators(newMenuListActions, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RelList);
